// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S1zz","footer":"styles_footer__13Kmw"};